import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';

import Loader from '../Loader';

import { actionMapForOtherLoaders } from 'constants/actions';
import { useAppSelector } from 'modules/state-mgmt/store';

interface IPublicRouteProps {
  noContainer?: boolean;
}

const PublicRoute = ({ noContainer }: IPublicRouteProps) => {
  const { loader } = useAppSelector(state => ({
    loader: state.loader,
  }));

  return loader.dataLoaders?.[actionMapForOtherLoaders.authenticateUser]?.isLoading ? (
    <Loader />
  ) : noContainer ? (
    <Outlet />
  ) : (
    <Container maxWidth="xl">
      <Outlet />
    </Container>
  );
};

export default memo(PublicRoute);
